export default defineAppConfig({
    icon: {
        customize: (content, name, prefix, provider) => {
            return content
                .replace(/fill="(?!none)[^"]*"/g, 'fill="currentColor"')
                .replace(/stroke="(?!none)[^"]*"/g, 'stroke="currentColor"')
        },
        size: '1rem'
    }
})
